import { object, string } from 'yup'
import { t } from 'ttag'

import { PROJECT_TITLE_FIELD } from './model'

export const PROJECT_TITLE_FIELD_LIMIT = 100

export const getSchema = () =>
  object().shape({
    [PROJECT_TITLE_FIELD]: string()
      .max(
        PROJECT_TITLE_FIELD_LIMIT,
        t`Position title cannot exceed 100 characters.`,
      )
      .required(t`This field cannot be empty.`),
  })
